import { PlaylistMusicOutlineIcon } from './PlaylistMusicOutlineIcon';

/**
 * author: Google
 * id 97526C1D-E3B9-4900-8C13-3969E80949B3
 * name playlist-music-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-music-outline.svg
 * tags
 * - Music 
 */
export const QueueMusicOutlineIcon = PlaylistMusicOutlineIcon;
export default QueueMusicOutlineIcon